"use client"

import { useEffect } from "react"
import { FiX, FiCheckCircle, FiAlertCircle } from "react-icons/fi"

const Notification = ({ type, message, onClose }) => {
  useEffect(() => {
    // Auto close after 3 seconds
    const timer = setTimeout(() => {
      onClose()
    }, 3000)

    // Clean up timer
    return () => clearTimeout(timer)
  }, [onClose])

  return (
    <div className="fixed top-5 right-5 z-50 max-w-md animate-slideIn">
      <div
        className={`flex items-center justify-between p-4 rounded-lg shadow-lg ${
          type === "success"
            ? "bg-gradient-to-r from-green-50 to-green-100 border-l-4 border-green-500"
            : "bg-gradient-to-r from-red-50 to-red-100 border-l-4 border-red-500"
        }`}
      >
        <div className="flex items-center">
          {type === "success" ? (
            <FiCheckCircle className="text-green-500 text-xl mr-3" />
          ) : (
            <FiAlertCircle className="text-red-500 text-xl mr-3" />
          )}
          <p className={`font-medium ${type === "success" ? "text-green-700" : "text-red-700"}`}>{message}</p>
        </div>
        <button
          onClick={onClose}
          className={`ml-4 p-1 rounded-full hover:bg-opacity-20 ${
            type === "success" ? "hover:bg-green-200" : "hover:bg-red-200"
          }`}
        >
          <FiX className={`${type === "success" ? "text-green-500" : "text-red-500"}`} />
        </button>
      </div>
    </div>
  )
}

export default Notification
